import { render, staticRenderFns } from "./PreparePhoto.vue?vue&type=template&id=4ca25576&scoped=true&"
import script from "./PreparePhoto.vue?vue&type=script&lang=js&"
export * from "./PreparePhoto.vue?vue&type=script&lang=js&"
import style0 from "./PreparePhoto.vue?vue&type=style&index=0&id=4ca25576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca25576",
  null
  
)

export default component.exports